(function () {
  var timer;
  var releaseTimer;

  function stabilizeVariantView() {
    if (document.getElementById('variant-switch-stability-style')) return;
    var style = document.createElement('style');
    style.id = 'variant-switch-stability-style';
    style.textContent =
      '.product__info-container > *, .product__info-container .price, .product__info-container variant-selects, .product__info-container .product-form, ul[id^="Slider-Gallery-"] > li.product__media-item, ul[id^="Slider-Gallery-"] > li.product__media-item img { animation: none !important; transition: none !important; }' +
      '.variant-switch-pending .product__info-container .price__badge, .variant-switch-pending .product__info-container .price__badge-sold-out, .variant-switch-pending .product__info-container .price__badge-sold_out { visibility: hidden !important; }';
    document.head.appendChild(style);
  }

  function filterVariantGallery() {
    document.querySelectorAll('ul[id^="Slider-Gallery-"]').forEach(function (gallery) {
      var sectionId = gallery.id.replace('Slider-Gallery-', '');
      var picker = document.getElementById('variant-selects-' + sectionId);
      var furInput = picker && picker.querySelector('[data-option-name="faux-fur"] input[type="radio"]:checked');
      var configElement = picker && picker.querySelector('[data-variant-gallery-config]');
      if (!furInput || !configElement) return;

      var config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      var matching = Object.keys(config).map(function (id) {
        return config[id];
      }).filter(function (entry) {
        return entry && entry.fur === furInput.value;
      });
      if (!matching.length) return;

      var sizeSelect = picker.querySelector('select[name="options[Size]"]');
      var size = sizeSelect && sizeSelect.value;
      var selected = matching.find(function (entry) {
        return size && entry.size === size;
      }) || matching.find(function (entry) {
        return entry.extraMediaIds && entry.extraMediaIds.length;
      }) || matching[0];

      var mainId = selected.mainMediaId == null ? '' : String(selected.mainMediaId);
      var visibleIds = new Set([mainId]);
      (selected.extraMediaIds || []).forEach(function (id) {
        visibleIds.add(String(id));
      });

      var items = Array.prototype.slice.call(gallery.children).filter(function (item) {
        return item.matches('li.product__media-item');
      });
      if (!items.length) return;

      var prefix = sectionId + '-';
      var visibleItems = [];
      items.forEach(function (item) {
        var mediaId = (item.getAttribute('data-media-id') || '').replace(prefix, '');
        var visible = visibleIds.has(mediaId);
        item.hidden = !visible;
        item.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) visibleItems.push(item);
      });

      if (!visibleItems.length) {
        items[0].hidden = false;
        items[0].setAttribute('aria-hidden', 'false');
        visibleItems.push(items[0]);
      }

      var active = gallery.querySelector('li.product__media-item.is-active');
      if (!active || active.hidden) {
        if (active) active.classList.remove('is-active');
        active = visibleItems.find(function (item) {
          return item.getAttribute('data-media-id') === prefix + mainId;
        }) || visibleItems[0];
        active.classList.add('is-active');
      }

      var thumbnails = document.getElementById('Slider-Thumbnails-' + sectionId);
      if (thumbnails) {
        Array.prototype.forEach.call(thumbnails.children, function (thumbnail) {
          var mediaId = (thumbnail.getAttribute('data-target') || '').replace(prefix, '');
          var visible = visibleIds.has(mediaId) || thumbnail.getAttribute('data-target') === visibleItems[0].getAttribute('data-media-id');
          thumbnail.hidden = !visible;
          var button = thumbnail.querySelector('button');
          if (button) {
            if (thumbnail.getAttribute('data-target') === active.getAttribute('data-media-id')) {
              button.setAttribute('aria-current', 'true');
            } else {
              button.removeAttribute('aria-current');
            }
          }
        });
      }

      var mediaGallery = gallery.closest('media-gallery');
      var total = mediaGallery && mediaGallery.querySelector('.slider-counter--total');
      var current = mediaGallery && mediaGallery.querySelector('.slider-counter--current');
      var activeIndex = visibleItems.indexOf(active) + 1;
      if (total && total.textContent.trim() !== String(visibleItems.length)) total.textContent = String(visibleItems.length);
      if (current && current.textContent.trim() !== String(activeIndex)) current.textContent = String(activeIndex);
    });
  }

  function finishSwitch() {
    window.clearTimeout(releaseTimer);
    releaseTimer = window.setTimeout(function () {
      document.body.classList.remove('variant-switch-pending');
      stabilizeVariantView();
      filterVariantGallery();
    }, 180);
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      stabilizeVariantView();
      filterVariantGallery();
      finishSwitch();
    }, 80);
  }

  document.addEventListener('DOMContentLoaded', function () {
    stabilizeVariantView();
    filterVariantGallery();
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('variant-radios')) {
      document.body.classList.add('variant-switch-pending');
      window.clearTimeout(releaseTimer);
      releaseTimer = window.setTimeout(function () {
        document.body.classList.remove('variant-switch-pending');
      }, 900);
    }
    schedule();
  }, true);

  document.addEventListener('variantChange', schedule);
  window.addEventListener('load', schedule);
  stabilizeVariantView();
  filterVariantGallery();
})();